import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from "react-i18next";
import DataTable from '../components/common/DataTable'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomModal from "../components/common/CustomModal";
import CreateContacts from '../components/contacts/createcontacts';
import { getCompanies, getRating, getLeadSource, getLeadStatus, getCountries, getBusinessGroup, getContactDepartments, getOwner, getClientCompany, getTitles, getColorPlate, getColorById } from '../services/CommonServices'
import { Delete_Contact_contactId, GET_contact } from "../services/apiRoutes";
import UpdateContacts from "../components/contacts/UpdateContacts";
import CustomDelete from '../components/common/CustomDeleteAlert'
import axios from "axios";
import MessageBox from "../components/common/CustomMessageBox";
import { AuthContext } from "../context/AuthContext";
import ContactsView from "../components/contacts/ContactsView";
import CustomLoader from "../components/common/CustomLoader";
import { ClearRounded, } from "@mui/icons-material";
import CustomButton from "../components/common/CustomButton";
import CustomTextField from "../components/common/CustomTextField";
import CustomAutocomplete from "../components/common/CustomAutoComplete";
import CustomFilter from "../components/common/CustomFilter";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { genericPost } from "../services/authServices";
import { hasEditPermission, hasDeletePermission } from '../services/CommonServices'
import { useLocation } from "react-router-dom";
import CustomDataTable from "../components/common/CustomDataTable";
import CustomStatus from "../components/common/CustomStatus";



const title = 'Contacts';

const Contacts = () => {

  const [modal, setModal] = useState(false);
  const [leadSource, setLeadSource] = useState([]);
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [businessGroup, setBusinessGroup] = useState([]);
  const [contactDepartments, setContactDepartments] = useState([]);
  const [owner, setOwner] = useState([]);
  const [clientCompany, setClientCompany] = useState([]);
  const [conutries, setConutries] = useState([]);
  const { token } = useContext(AuthContext)
  const [viewModal, setViewModal] = useState(false);
  const [titles, setTitles] = useState([]);
  const [permission, setPermissions] = useState()
  const [page, setPage] = useState(0); // UI 0-based
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [colorlist, setColorlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [error, setError] = useState(null);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [rowId, setRowId] = useState('');
  const [openDrawer, setOpenDrawer] = useState(false);

  const [message, setMessage] = useState({
    open: false,
    text: '',
    type: ''
  })
  const [filterPayload, setFilterPayload] = useState({
    selectCompanyNameId: '',
    departmentId: '',
    businessGroupId: '',
    millingCountryId: '',
    fromDate: '',
    toDate: '',

  });



  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentDate = new Date();
  const sevenDaysAgo = new Date(currentDate);
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);

  const [selectedId, setSelectedId] = useState(null); // State to hold selected ID
  const [updateModal, setUpdateModal] = useState(false);
  const filterOpen = () => setOpenDrawer(true);
  const filterClose = () => setOpenDrawer(false);

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
    let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
    let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
    setPermissions({
      edit: editPermision,
      delete: deletePermission
    })
  }, [])


  const handleUpdateClick = (contactId) => {
    setSelectedId(contactId);
    setUpdateModal(true);
  };

  const handleCloseUpdateModal = () => {
    setUpdateModal(false);
  };
  const handleOpenView = (contactId) => {
    setSelectedId(contactId);
    setViewModal(true);
  };

  const handleCloseView = () => {
    setViewModal(false);
    setSelectedId('');
  };

  const handleViewClick = (contactId) => {
    handleOpenView(contactId);
    setSelectedId(contactId);

  };

  const handleOpenDeleteAlert = (rowId) => {
    setDeleteAlert(true);
    setRowId(rowId);
  };

  const handleFilterChange = (field, value) => {
    setFilterPayload((prev) => ({
      ...prev,
      [field]: value || '',
    }));
  };
  const handleClearFilters = useMemo(() => {
    return () => {
      setFilterPayload({
        selectCompanyNameId: '',
        departmentId: '',
        businessGroupId: '',
        millingCountryId: '',
        fromDate: '',
        toDate: '',
      });
      fetchContacts(0, pageSize, '');
    };
  }, [pageSize]);


  useEffect(() => {
    fetchContacts(page, pageSize)
  }, [token, page, pageSize, colorlist])

  useEffect(() => {
    getCommonData();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "index", header: "SN.", size: 50,
        tableStyle: { textAlign: "center" }, enableColumnFilter: false
      },
      {
        accessorKey: "firstName", header: "Contacts Name", size: 50,
        tableHeader: {
          justifyContent: 'flex-start',
        },
        enableSorting: false,
      },
      { accessorKey: "mobile", header: "Contacts No.", size: 50, tableStyle: { textAlign: "center" }, enableSorting: false, },
      {
        accessorKey: "email", header: "Email ID", size: 50, enableSorting: false,
        tableHeader: {
          justifyContent: 'flex-start',
        },
        tableStyle: {
          textTransform: "lowercase",
        },
      },
      {
        accessorKey: "company", header: "Company", size: 50, enableSorting: false,
        tableHeader: {
          justifyContent: 'flex-start',
        },
      },
      {
        accessorKey: "millingCountry",
        header: "Country",
        tableStyle: { textAlign: "center" },
        size: 50,
        Cell: ({ row }) => {
          return (
            <CustomStatus
              title={row.original.millingCountry}
              sx={{
                backgroundColor: row.original.countryIdBackground,
                color: row.original.countryIdColor,
                border: `1px solid ${row.original.countryIdColor}`,
                textAlign: "center",
                display: "inline-block",
              }}
            />
          );
        },
        enableSorting: false,
      },

      {
        accessorKey: "action",
        header: "Action",
        size: 50,
        enableSorting: false,
        Cell: ({ row }) => (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
              <IconButton onClick={() => handleViewClick(row.original.contactId)} style={{ marginRight: '1px' }}>
                <VisibilityIcon style={{ color: '#059212' }} />
              </IconButton>
              {permission?.edit &&
                <IconButton onClick={() => handleUpdateClick(row.original.contactId)}>
                  <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                </IconButton>
              }
              {permission?.delete && <IconButton onClick={() => handleOpenDeleteAlert(row.original.contactId)}>
                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
              </IconButton>}
            </div>
          </>
        ),
      },
    ],
    [permission]
  );

  const fetchContacts = async (pageIndex = 0, pageSize = 10) => {
    setLoading(true);
    try {
      const payload = {
        page: pageIndex + 1,
        limit: pageSize,
        ...filterPayload
      };
      const response = await genericPost(GET_contact, payload, {});
      if (response.data.success && response.data.contacts) {
        const contactData = response.data.contacts.map((contact, index) => {
          const countryColorObj = getColorById(contact.millingCountryId, colorlist, {
            matchKey: "colorId",
            prefixLength: 1,
          });
          return {
            contactId: contact.contactId || '',
            index: (index + 1).toString().padStart(2, '0'),
            title: contact.title || '',
            description: contact.description || '',
            email: contact.email || '',
            firstName: contact ? `${contact.firstName} ${contact.lastName}` : '',
            mobile:
              contact.mobile
                ? contact.phonecode?.phonecode
                  ? `+${contact.phonecode.phonecode}${contact.mobile}`
                  : `${contact.mobile}`
                : '',
            otherPhone: contact.otherPhone || '',
            phone: contact.phone || '',
            skypeId: contact.skypeId || '',
            assistant: contact.assistant || '',
            dateOfBirth: contact.dateOfBirth || '',
            mailingStreet: contact.mailingStreet || '',
            millingCountry: contact.millingCountry?.name || '',
            millingState: contact.millingState?.name || '',
            millingCity: contact.millingCity?.name || '',
            otherStreet: contact.othersStreet || '',
            otherCountry: contact.OthersCountry?.name || '',
            otherState: contact.OthersState?.name || '',
            otherCity: contact.OthersCity?.name || '',
            otherPincode: contact.otherPincode || '',
            createdAt: contact.createdAt || '',
            updatedAt: contact.updatedAt || '',
            user: contact.user ? `${contact.user.firstName} ${contact.user.lastName}` : '',
            company: contact.clientCompany?.clientCompanyName || '',
            leadSource: contact.leadSource?.leadSourceName || '',
            reportingTo: contact.reportingTo || '',
            department: contact.department || '',
            countryIdColor: countryColorObj.color || '',
            countryIdBackground: countryColorObj.backgroundColor || '',
          };
        });
        setContacts(contactData);
        setRowCount(response.data.pagination?.totalRecords || 0);

      } else {
        setError('No contacts found');
      }
    } catch (error) {
      setError('Error fetching contacts');
      console.error('Error fetching contacts', error);
    } finally {
      setLoading(false);
    }
  };
  const getCommonData = async () => {
    const leadSourceData = await getLeadSource();
    setLeadSource(leadSourceData);
    const countriesData = await getCountries();
    setCountries(countriesData);
    const companiesData = await getCompanies();
    setCompanies(companiesData);
    const businessGroupData = await getBusinessGroup();
    setBusinessGroup(businessGroupData);
    const contactDepartmentsData = await getContactDepartments();
    setContactDepartments(contactDepartmentsData);
    const owner = await getOwner();
    setOwner(owner);
    const clientCompany = await getClientCompany();
    setClientCompany(clientCompany);
    const getConutriesData = await getCountries()
    setConutries(getConutriesData);
    const titlesData = await getTitles()
    setTitles(titlesData);
    const colorData = await getColorPlate();
    setColorlist(colorData);
  };

  const handleOpen = () => {
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
  };

  const handleDelete = async (contactId) => {
    setLoading(true);
    const authToken = sessionStorage.getItem('accessToken');
    try {
      const response = await axios.delete(Delete_Contact_contactId(contactId), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 200) {
        fetchContacts();
        setDeleteAlert(false);
        setMessage({
          open: true,
          text: response?.data?.message || "Delete successfully",
          type: "success",
        });
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error deleting contact", error);
    }
  };

  return (
    <>
      <Box sx={{ padding: '10px' }}>
        <CustomLoader open={loading} />
        <CustomDataTable
          title={title}
          columns={columns}
          data={contacts}
          handleOpen={handleOpen}
          buttonTitle="Create"
          handleFilterButton={filterOpen}
          fiterButtonTitile="Filter"
          rowCount={rowCount}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          fromDate={filterPayload.fromDate || ""}
          toDate={filterPayload.toDate || ""}

        />
        <CustomModal open={modal}  >
          <CreateContacts
            handleClose={handleClose}
            leadSource={leadSource}
            owner={owner}
            titles={titles}
            conutries={conutries}
            contacts={contacts}
            clientCompany={clientCompany}
            fetchContacts={fetchContacts}
            setMessage={setMessage}
            companies={companies}
            businessGroups={businessGroup}
            contactDepartments={contactDepartments}
          />
        </CustomModal>

        <CustomModal
          open={updateModal}
        >
          <UpdateContacts
            handleClose={handleCloseUpdateModal}
            contacts={contacts.find((v) => v.contactId === selectedId)}
            contactId={selectedId}
            fetchContacts={fetchContacts}
            setMessage={setMessage}
            leadSource={leadSource}
            reportTo={contacts}
            titles={titles}
            companies={companies}
            owner={owner}
            conutries={conutries}
            clientCompany={clientCompany}
            businessGroups={businessGroup}
            contactDepartments={contactDepartments}
          />
        </CustomModal>

        <CustomModal
          open={viewModal}
          modalStyles={{
            maxHeight: '45vh',
            top: "10%",
          }}
          handleClose={handleCloseView}>
          <ContactsView
            handleClose={handleCloseView}
            contacts={contacts.find((v) => v.contactId === selectedId)}
            contactId={selectedId}
            fetchContacts={fetchContacts}
            setMessage={setMessage}
            leadSource={leadSource}
            companies={companies}
            owner={owner}
            conutries={conutries}
            clientCompany={clientCompany}
            businessGroups={businessGroup}
            contactDepartments={contactDepartments}
          />
        </CustomModal>

        <MessageBox
          open={message.open}
          onClose={() => setMessage({ ...message, open: false })}
          message={message.text}
          handleClose={() => setMessage({ ...message, open: false })}
          type={message.type}
        />
        <CustomDelete
          handleDelete={handleDelete}
          open={deleteAlert}
          rowId={rowId}
          handleClose={() => setDeleteAlert(false)}
        />
        <CustomFilter
          drawerTitle="Filter"
          drawerWidth={300}
          openDrawer={openDrawer}
          onClose={filterClose}
          drawerContent={
            <>
              <Box>
                <Grid container spacing={1} sx={{ padding: 0, }}>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={clientCompany}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Company"
                      onChange={(event, newValue) => handleFilterChange("selectCompanyNameId", newValue?.id)}
                      value={clientCompany.find((item) => item.id === filterPayload.selectCompanyNameId) || null}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={conutries}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Country"
                      onChange={(event, newValue) => handleFilterChange("millingCountryId", newValue?.id)}
                      value={conutries.find((item) => item.id === filterPayload.millingCountryId) || null}

                    />

                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={contactDepartments}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Department"
                      onChange={(event, newValue) => handleFilterChange("departmentId", newValue?.id)}
                      value={contactDepartments.find((item) => item.id === filterPayload.departmentId) || null}

                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomAutocomplete
                      options={businessGroup}
                      getOptionLabel={(option) => option.title}
                      placeholder="Business Group"
                      onChange={(event, newValue) => handleFilterChange("businessGroupId", newValue?.id)}
                      value={businessGroup.find((item) => item.id === filterPayload.businessGroupId) || null}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="From Date"
                      type="date"
                      value={filterPayload.fromDate}
                      onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                      placeholder="From Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="To Date"
                      type="date"
                      value={filterPayload.toDate}
                      onChange={(e) => handleFilterChange('toDate', e.target.value)}
                      placeholder="To Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                    <CustomButton
                      startIcon={<FindReplaceOutlinedIcon />}
                      title="Apply"
                      size="small"
                      variant="contained"
                      onClick={fetchContacts}
                    />
                    <CustomButton
                      variant="outlined"
                      title="Clear"
                      startIcon={<ClearRounded />}
                      style={cif_fob_style}
                      onClick={handleClearFilters}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          }
        />

      </Box>
    </>
  );
};

export default Contacts;
const cif_fob_style = {
  backgroundColor: '#ffff',
  color: '#007bff',
  textTransform: "capitalize",
  borderRadius: 4,
  border: '1px solid #007bff',
  height: 30,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: "100px"
}


